<template>
    <span>
        <el-popover
            v-if="config.responseType === 'popoverPage' && config.popoverPageData"
            :placement="popoverPlacement"
            :trigger="popoverTrigger"
            :width="config.popoverWidth || 400"
            :popper-class="config.popupClass || ''"
        >
            <template #reference>
                <span class="text-item-wrap text-item-wrap--interactive" :style="textStyle">
                    {{ getLocaleText(showText) }}
                </span>
            </template>
            <PopoverPageRender
                :area-data="config.popoverPageData"
                :width="config.popoverWidth || 400"
            />
        </el-popover>

        <component
            v-else
            :is="safeLink ? 'a' : 'div'"
            class="text-item-wrap"
            :target="jumpWay"
            :href="safeLink || undefined"
            :style="textStyle"
            @click="textClickFn"
        >
            {{ getLocaleText(showText) }}
        </component>

        <!-- Popup Dialog -->
        <el-dialog v-if="config.responseType === 'popup'" :class="config.popupClass || ''"
            :title="config.popupTitle || ''" append-to-body v-model="dialogTableVisible">
            <template #default>
                <div v-if="dialogTableVisible" class="new-detail-item-cont" v-html="articleContent.content"></div>
            </template>
            <template #footer>
                <el-button type="primary" @click="dialogTableVisible = false">{{ getLocaleText('关闭') }}</el-button>
            </template>
        </el-dialog>
    </span>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { getArticleDetails } from "@/api";
import { getSafeLink, isTarget_Blank } from "@/utils/globalData.js";
import { useRenderConfig } from './uses/useRenderConfig.js';
import { resolveBindDataKeyValue } from '@/utils/renderBinding';
import PopoverPageRender from "@/components/render/PopoverPageRender.vue";


// 获取公共配置的 mixin
import useLocate from './uses/useLocate.js';

const props = defineProps({
    currentElementIndex: {
        type: Array,
        default: () => [],
    },
    idx: {
        type: Number,
        default: -1,
    },
    parentKeys: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: true,
    },
    config: {
        type: Object,
    },
});

const dialogTableVisible = ref(false);
const articleContent = ref('');


let {
    langJson,
    nowLocale,
    getLocaleText,
} = useLocate()
const { bindData } = useRenderConfig(() => props.config);

const showText = computed(() => {
    return resolveBindDataKeyValue(
        bindData.value,
        props.config?.bindDataKey,
        props.config?.text || "",
    );
});

const textStyle = computed(() => {
    return {
        textAlign: props.config?.textAlign,
        fontSize: `${props.config?.fontSize || 14}px`,
        fontWeight: props.config?.fontWeight,
        color: props.config?.fontColor,
        lineHeight: props.config?.lineHeight,
    };
});

const popoverPlacement = computed(() => {
    return props.config?.popoverPlacement || "right";
});

const popoverTrigger = computed(() => {
    return props.config?.popoverTrigger || "hover";
});

const safeLink = computed(() => {
    if (!["link", "jumpLink"].includes(props.config?.responseType || "link")) {
        return "";
    }
    return getSafeLink(props.config?.link);
});
// 获取文章内容
const getArticleContent = async () => {
    if (props.config.responseType !== "popup") {
        return;
    }
    const param = {
        pageNo: 0,
        pageSize: 9999,
        id: props.config.article.id,
        status: "1",
    };
    const res = await getArticleDetails(param);
    if (res.data.dataList) {
        articleContent.value = res.data.dataList[0];
        if (articleContent.value.type === 1 && articleContent.value.content) {
            articleContent.value.content = articleContent.value.content.replace('video', 'video autoplay ');
        }
    }
};

// 响应式的计算
const currentElementIndexStr = computed(() => {
    return props.currentElementIndex.length ? props.currentElementIndex.join("x") : "";
});

// 处理跳转方式
const jumpWay = computed(() => {
    switch (props.config.responseType) {
        case 'link':
            return '_Self';
        case 'jumpLink':
            return isTarget_Blank();
        default:
            return '_Self';
    }
});

// 监听配置的变化
watch(() => props.config.article, (value) => {
    if (value) getArticleContent();
}, { deep: true });

watch(() => props.config, () => {
    // 其他配置变化时的逻辑
}, { deep: true, immediate: true });

// 初始化时获取文章内容
onMounted(() => {
    getArticleContent();
});

// 方法
const textClickFn = () => {
    if (props.config.responseType !== 'popup') {
        return;
    }
    dialogTableVisible.value = true;
};

</script>

<style scoped>
.text-item-wrap {
    display: block;
    text-decoration: none;
}
.text-item-wrap--interactive {
    cursor: pointer;
}
</style>
